










































































import {
  defineComponent,
  ref,
  computed,
} from '@vue/composition-api';
import type { CouponRolePo } from '@/api/coupon/types';
import { DownArrowOutline12 } from '@hb/coffee-icons';

// static component
// [功能说明]: 优惠券卡片组件
interface Props {
  coupon: CouponRolePo;
  isAvailable?: boolean;
  index?: number;
}

export default defineComponent({
  name: 'CouponCard',
  components: {
    DownArrowOutline12,
  },
  props: {
    coupon: {
      type: Object as () => CouponRolePo,
      required: true,
    },
    isAvailable: {
      type: Boolean,
      default: true,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  emits: ['select'],
  setup(props: Props, { emit }) {
    // 展开状态管理
    const isExpanded = ref(false);

    // 格式化日期
    const formatDate = (dateString: string) => {
      if (!dateString) return '';
      return dateString.substring(0, 10);
    };

    // 检查是否有长描述信息
    const hasLongComments = computed(() => props.coupon.comments
    && props.coupon.comments.length > 24);

    // 显示的描述信息
    const displayComments = computed(() => {
      if (!props.coupon.comments) return '';

      if (!isExpanded.value) {
        return props.coupon.comments.length > 24
          ? `${props.coupon.comments.substring(0, 24)}...`
          : props.coupon.comments;
      }

      return props.coupon.comments;
    });

    // 处理卡片点击
    const handleCardClick = () => {
      if (props.isAvailable) {
        emit('select', props.coupon, props.index);
      }
    };

    // 处理展开/收起
    const handleToggleDetails = () => {
      if (hasLongComments.value) {
        isExpanded.value = !isExpanded.value;
      }
    };

    return {
      isExpanded,
      formatDate,
      hasLongComments,
      displayComments,
      handleCardClick,
      handleToggleDetails,
    };
  },
});
